module.exports = __webpack_public_path__ + "static/media/research-icon.898c6cae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/research-icon.svg
// module id = 1921
// module chunks = 0